"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.remove = exports.add = exports.createUserInputNeededArtifact = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const createUserInputNeededArtifact = ({ referenceArtifact, }) => {
    return {
        id: (0, uuid_1.v4)(),
        type: 'userInputNeeded',
        configuration: {
            inputType: 'dataLakeTableHydration',
        },
        loanProductSlug: null,
        creditFacilitySlug: null,
        artifactDocumentId: referenceArtifact.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `userInputNeeded_${referenceArtifact.artifactSlug}`,
    };
};
exports.createUserInputNeededArtifact = createUserInputNeededArtifact;
const edgeToString = (edge) => `${edge.inputArtifactId} => ${edge.outputArtifactId}`;
// Before:
// +------------------------+                +-----------------------+
// |                        |                |                       |
// |  waitForDataLakeTable  +--------------->| WhatEver              |
// |                        |                |                       |
// +------------------------+                +-----------------------+
// After:
// +------------------------+                +-----------------------+                +-----------------------+
// |                        |                |                       |                |                       |
// |  waitForDataLakeTable  +--------------->| UserInputNeeded       |--------------->| WhatEver              |
// |                        |                |                       |                |                       |
// +------------------------+                +-----------------------+                +-----------------------+
// create a synthetic node userInputNeeded which goes between
// waitForDataLakeTable => userInputNeeded => Whatever.
//
// for each artifact of type "waitForDataLakeTable"
//  1. create a new artifact of type "userInputNeeded"
//  2. create a new dependency between waitForDataLakeTable => userInputNeeded
//  For each output of waitForDataLakeTable
//      3. create a new dependency between userInputNeeded => whatever
//      4. remove the dependency between waitForDataLakeTable => whatever
const add = (dbGraph) => {
    const waitForDataLakeTables = utils.filterWaitForDataLakeTables(dbGraph);
    const newDependencies = [];
    const dependenciesToBeRemoved = [];
    const newArtifacts = [];
    waitForDataLakeTables.forEach((waitForDataLakeTable) => {
        const userInputNeeded = (0, exports.createUserInputNeededArtifact)({
            referenceArtifact: waitForDataLakeTable,
        });
        // 1) + userInputNeeded.
        newArtifacts.push(userInputNeeded);
        // 2) + waitForDataLakeTable => userInputNeeded.
        newDependencies.push({
            inputArtifactId: waitForDataLakeTable.id,
            outputArtifactId: userInputNeeded.id,
        });
        // find all outputEdges of waitForDataLakeTable.
        const outputEdges = dbGraph.dataTapeDependencies.filter(({ inputArtifactId }) => inputArtifactId === waitForDataLakeTable.id);
        outputEdges.forEach((outputEdge) => {
            // 3) + userInputNeeded => whatever.
            newDependencies.push({
                inputArtifactId: userInputNeeded.id,
                outputArtifactId: outputEdge.outputArtifactId,
            });
            // 4) - waitForDataLakeTable => whatever.
            dependenciesToBeRemoved.push(edgeToString(outputEdge));
        });
    });
    // remove waitForDataLakeTable => whatever.
    const dataTapeDependencies = dbGraph.dataTapeDependencies.filter((dataTapeDependency) => !dependenciesToBeRemoved.includes(edgeToString(dataTapeDependency)));
    const output = {
        dataTapes: [...dbGraph.dataTapes, ...newArtifacts],
        dataTapeDependencies: [...dataTapeDependencies, ...newDependencies],
    };
    return output;
};
exports.add = add;
// Before:
// +------------------------+                +------------------------+                +-----------------------+
// |                        |                |                        |                |                       |
// |  waitForDataLakeTable  +--------------->| UserInputNeeded        |--------------->| WhatEver              |
// |                        |                |(dataLakeTableHydration)|                |                       |
// +------------------------+                +------------------------+                +-----------------------+
// After:
// +------------------------+                +-----------------------+
// |                        |                |                       |
// |  waitForDataLakeTable  +--------------->| WhatEver              |
// |                        |                |                       |
// +------------------------+                +-----------------------+
// for each artifact of type "userInputNeeded" which has inputType "dataLakeTableHydration"
//  1. find the artifact which is connected to this artifact.
//  2. remove the dependency between userInputNeeded => whatever
//  3. create a new dependency between waitForDataLakeTable => whatever
//  4. remove the userInputNeeded artifact
const remove = (dbGraph) => {
    const userInputNeededNodes = utils.filterUserInputNeededNodesDataLakeWait(dbGraph);
    const newDependencies = [];
    const dependenciesToBeRemoved = [];
    userInputNeededNodes.forEach((userInputNeededNode) => {
        (0, common_1.finleyAssert)(userInputNeededNode.configuration.inputType === 'dataLakeTableHydration', 'Invalid configuration for userInputNeededNode');
        const inputNodeIds = dbGraph.dataTapeDependencies
            .filter(({ outputArtifactId }) => outputArtifactId === userInputNeededNode.id)
            .map(({ inputArtifactId }) => inputArtifactId);
        (0, common_1.finleyAssert)(inputNodeIds.length === 1, `userInputNeededNode must have exactly one artifact as input but [found:${inputNodeIds.length}], [id:${userInputNeededNode.id}]`);
        const waitArtifactId = inputNodeIds[0];
        // find all outputEdges of userInputNeededNode.
        const outputEdges = dbGraph.dataTapeDependencies.filter(({ inputArtifactId }) => inputArtifactId === userInputNeededNode.id);
        // - waitArtifact => userInputNeededNode.
        dependenciesToBeRemoved.push(edgeToString({
            inputArtifactId: waitArtifactId,
            outputArtifactId: userInputNeededNode.id,
        }));
        outputEdges.forEach((outputEdge) => {
            // - userInputNeededNode => whatever.
            dependenciesToBeRemoved.push(edgeToString(outputEdge));
            // + waitArtifactId => whatever.
            newDependencies.push({
                inputArtifactId: waitArtifactId,
                outputArtifactId: outputEdge.outputArtifactId,
            });
        });
    });
    const userInputNeededNodeIds = userInputNeededNodes.map(({ id }) => id);
    // filter out userInputNeededNodes and their dependencies.
    const dataTapes = dbGraph.dataTapes.filter((dataTape) => !userInputNeededNodeIds.includes(dataTape.id));
    const dataTapeDependencies = dbGraph.dataTapeDependencies.filter((dataTapeDependency) => !dependenciesToBeRemoved.includes(edgeToString(dataTapeDependency)));
    const output = {
        dataTapes,
        dataTapeDependencies: [...dataTapeDependencies, ...newDependencies],
    };
    return output;
};
exports.remove = remove;
exports.syntheticProcess = {
    toDb: exports.add,
    fromDb: exports.remove,
};
//# sourceMappingURL=datalakeWaitUserInput.js.map